import { apiClient } from "../api";
import { CreateSubsidiaryDto, Subsidiary, UpdateSubsidiaryDto } from "../generated/client";

export const createSubsidiary = async (data: CreateSubsidiaryDto): Promise<Subsidiary> => {
    try {
        const response = await apiClient.subsidiaries.create(data);
        return response.data;
    } catch (error) {
        console.error("create subsidiary:", error);
        throw error;
    }
};

export const getAllSubsidiaries = async (): Promise<Array<Subsidiary>> => {
    try {
        const response = await apiClient.subsidiaries.findAll();
        return response.data;
    } catch (error) {
        console.error("fetch subsidiaries:", error);
        throw error;
    }
};

export const getSubsidiaryById = async (id: string): Promise<Subsidiary> => {
    try {
        const response = await apiClient.subsidiaries.findOne(id);
        return response.data;
    } catch (error) {
        console.error(`fetch subsidiary by ID ${id}:`, error);
        throw error;
    }
};

export const updateSubsidiary = async (id: string, data: UpdateSubsidiaryDto): Promise<Subsidiary> => {
    try {
        const response = await apiClient.subsidiaries.update(id, data);
        return response.data;
    } catch (error) {
        console.error(`update subsidiary by ID ${id}:`, error);
        throw error;
    }
};

export const removeSubsidiary = async (id: string): Promise<void> => {
    try {
        await apiClient.subsidiaries.remove(id);
    } catch (error) {
        console.error(`removing subsidiary by ID ${id}:`, error);
        throw error;
    }
};
